import React from 'react';
import styled from 'styled-components';

import { Label } from 'rbx';

import {
  CheckBox,
  Select,
  TextArea,
  // InputErrorMessage,
} from '../../../components/elements';

const Container2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

const PaddingDiv = styled.div`
  padding: ${props => props.verticalPadding || '1rem'}
    ${props => props.horizontalPadding || '0rem'};
`;

const Info = styled.p`
  color: #b0b0b0;
  font-size: 12px;
`;

const autoReminder = [2, 4, 8, 12, 16, 24, 36].map(ele => ({
  value: ele,
  label: ele,
}));

const autoReminderObj = autoReminder.reduce((prev, curr) => {
  const temp = { ...prev };
  temp[curr.value] = curr;
  return temp;
}, {});

const NotificationSettings = ({
  values,
  setFieldValue,
  handleChange,
  handleBlur,
  touched,
  errors,
}) => (
  <div style={{ paddingLeft: '4px' }}>
    <Container2>
      <div>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              Venue Email Notification on New Booking
            </div>
            <CheckBox
              value={values.email_venue_new_booking}
              onChange={value =>
                setFieldValue('email_venue_new_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              User Email Notification on Confirmation
            </div>
            <CheckBox
              value={values.email_user_confirm_booking}
              onChange={value =>
                setFieldValue('email_user_confirm_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              User SMS Notification on Confirmation
            </div>
            <CheckBox
              value={values.sms_user_confirm_booking}
              onChange={value =>
                setFieldValue('sms_user_confirm_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              User SMS on booking modifications
            </div>
            <CheckBox
              value={values.sms_user_modified_booking}
              onChange={value =>
                setFieldValue('sms_user_modified_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
      </div>
      <div>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              Venue Email Notification on Cancel / Modify
            </div>
            <CheckBox
              value={values.email_venue_cancel_booking}
              onChange={value =>
                setFieldValue('email_venue_cancel_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              User Email Notification on Cancel / Modify
            </div>
            <CheckBox
              value={values.email_user_cancel_booking}
              onChange={value =>
                setFieldValue('email_user_cancel_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              Send Auto Reminder to user before booking time
            </div>
            <div style={{ width: '150px' }}>
              <Select
                options={autoReminder}
                value={[
                  autoReminderObj[
                    parseInt(values.auto_reminder_before_booking, 10)
                  ],
                ]}
                onChange={value => {
                  setFieldValue('auto_reminder_before_booking', value.value);
                }}
                disableToastMessage
              />
            </div>
            <div style={{ position: 'relative', top: '10px', left: '10px' }}>
              hr(s)
            </div>
          </Label>
        </PaddingDiv>
        <PaddingDiv>
          <Label className="is-flex">
            <div style={{ width: '400px' }}>
              User SMS Notification on Cancellation
            </div>
            <CheckBox
              value={values.sms_user_cancel_booking}
              onChange={value =>
                setFieldValue('sms_user_cancel_booking', value)
              }
            />
          </Label>
        </PaddingDiv>
      </div>
      <PaddingDiv>
        <Label>
          Message from Restaurant
          <Info>
            Share any special conditions with your guests that will appear on
            all email communications.
          </Info>
        </Label>
        <TextArea
          name="message_from_restaurant"
          value={values.message_from_restaurant}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.message_from_restaurant}
          touched={touched.message_from_restaurant}
          disableToastMessage
          optionalText="(Min 10 and Max 550 characters)"
        />
        {values.message_from_restaurant && (
          <div style={{ textAlign: 'right' }}>
            {values.message_from_restaurant.length > 550 ||
            values.message_from_restaurant.length < 10
              ? ''
              : `Characters left ${550 -
                  values.message_from_restaurant.length}`}
          </div>
        )}
      </PaddingDiv>
    </Container2>
  </div>
);

export default NotificationSettings;
